import { useAuthStore } from "@/stores/auth.store";
import { OPERATOR_TIMEZONE } from "@/features/production-orders/timeline-range";

// Timezone IANA da FÁBRICA (organização). Os turnos do expediente são
// declarados nesta hora local; resolver as janelas (faixas/aviso de OP) na tz da org — a MESMA que
// o servidor usa no sweep e na simulação — evita divergência quando o navegador do operador está em
// outro fuso. Fallback ao fuso do navegador só na ausência de sessão (fora do app autenticado).
export function useOrgTimezone(): string {
  return useAuthStore((s) => s.user?.organizationTimezone) ?? OPERATOR_TIMEZONE;
}
